import Lottie from 'lottie-react';

export const LottieView = Lottie;
